/* Moonhug — storefront interactions */
(function () {
  'use strict';

  var V = window.Moonhug || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var currency = V.moneyCurrency || 'USD';
  var fmt = function (cents) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(Number(cents) / 100); }
    catch (e) { return '$' + (Number(cents) / 100).toFixed(2); }
  };
  var lsGet = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var lsSet = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  var lsDel = function (k) { try { localStorage.removeItem(k); } catch (e) {} };
  var reducedMotion = function () { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } };

  /* ------------------------------------------------------------------ */
  /* Consent + advertising click attribution                            */
  /* ------------------------------------------------------------------ */
  var CONSENT_KEY = 'moonhug-consent';
  var TTCLID_KEY = 'moonhug-ttclid';
  var TTCLID_TTL = 10080 * 60 * 1000;

  function getConsent() {
    var v = lsGet(CONSENT_KEY);
    if (!v) return null;
    try { return JSON.parse(v); } catch (e) { return null; }
  }
  function hasMarketing() { var c = getConsent(); return !!(c && c.marketing === true); }

  function applyShopifyConsent(c) {
    var payload = { analytics: !!c.statistics, marketing: !!c.marketing, preferences: !!c.statistics, sale_of_data: !!c.marketing };
    var run = function () {
      try { window.Shopify.customerPrivacy.setTrackingConsent(payload, function () {}); } catch (e) {}
    };
    if (window.Shopify && window.Shopify.customerPrivacy) { run(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) run(); });
      } catch (e) {}
    }
  }

  function setConsent(statistics, marketing) {
    var c = { statistics: statistics, marketing: marketing, decidedAt: Date.now() };
    lsSet(CONSENT_KEY, JSON.stringify(c));
    applyShopifyConsent(c);
    return c;
  }

  function captureTtclid() {
    try {
      var id = new URLSearchParams(window.location.search).get('ttclid');
      if (id) lsSet(TTCLID_KEY, JSON.stringify({ id: id, ts: Date.now() }));
    } catch (e) {}
  }
  function getTtclid() {
    var raw = lsGet(TTCLID_KEY);
    if (!raw) return null;
    try {
      var o = JSON.parse(raw);
      if (Date.now() - o.ts > TTCLID_TTL) { lsDel(TTCLID_KEY); return null; }
      return o.id;
    } catch (e) { return null; }
  }
  function withTtclid(url) {
    var id = getTtclid();
    if (!id || !hasMarketing() || /[?&]ttclid=/.test(url)) return url;
    var parts = url.split('#');
    var base = parts[0];
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'ttclid=' + encodeURIComponent(id) + (parts.length > 1 ? '#' + parts[1] : '');
  }

  /* Advertising events are managed exclusively by wetracked.io. */

  function initConsentBanner() {
    var banner = $('[data-consent-banner]');
    if (!banner) return;
    var existing = getConsent();
    if (existing) { applyShopifyConsent(existing); return; }
    banner.hidden = false;
    var details = $('[data-consent-details]', banner);
    var stat = $('[data-consent-statistics]', banner);
    var mkt = $('[data-consent-marketing]', banner);
    var btnSettings = $('[data-consent-settings]', banner);
    var btnSave = $('[data-consent-save]', banner);
    var done = function (s, m) { setConsent(s, m); banner.hidden = true; };
    $('[data-consent-accept]', banner).addEventListener('click', function () { done(true, true); });
    $('[data-consent-reject]', banner).addEventListener('click', function () { done(false, false); });
    btnSettings.addEventListener('click', function () { details.hidden = false; btnSettings.hidden = true; btnSave.hidden = false; });
    btnSave.addEventListener('click', function () { done(!!stat.checked, !!mkt.checked); });
  }

  /* ------------------------------------------------------------------ */
  /* Toasts (sonner markup)                                              */
  /* ------------------------------------------------------------------ */
  var ICONS = {
    success: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>',
    error: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20" width="20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg>'
  };
  function toast(message, type) {
    var root = $('[data-toaster-root]');
    if (!root) return;
    var ol = $('ol', root);
    if (!ol) {
      ol = document.createElement('ol');
      ol.setAttribute('dir', 'ltr');
      ol.setAttribute('tabindex', '-1');
      ol.className = 'toaster group';
      ol.setAttribute('data-sonner-toaster', 'true');
      ol.setAttribute('data-sonner-theme', 'light');
      ol.setAttribute('data-y-position', 'bottom');
      ol.setAttribute('data-x-position', 'right');
      ol.setAttribute('style', '--front-toast-height: 53.5px; --width: 356px; --gap: 14px; --offset-top: 24px; --offset-right: 24px; --offset-bottom: 24px; --offset-left: 24px; --mobile-offset-top: 16px; --mobile-offset-right: 16px; --mobile-offset-bottom: 16px; --mobile-offset-left: 16px;');
      root.appendChild(ol);
    }
    $$('li', ol).forEach(function (li) { li.remove(); });
    var li = document.createElement('li');
    li.setAttribute('tabindex', '0');
    li.className = 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg';
    var attrs = { 'data-sonner-toast': '', 'data-styled': 'true', 'data-mounted': 'false', 'data-promise': 'false', 'data-swiped': 'false', 'data-removed': 'false', 'data-visible': 'true', 'data-y-position': 'bottom', 'data-x-position': 'right', 'data-index': '0', 'data-front': 'true', 'data-swiping': 'false', 'data-dismissible': 'true', 'data-type': type || 'success', 'data-swipe-out': 'false', 'data-expanded': 'false' };
    Object.keys(attrs).forEach(function (k) { li.setAttribute(k, attrs[k]); });
    li.setAttribute('style', '--index: 0; --toasts-before: 0; --z-index: 1; --offset: 0px; --initial-height: 53.5px;');
    li.innerHTML = '<div data-icon="" class="">' + (ICONS[type] || ICONS.success) + '</div><div data-content="" class=""><div data-title="" class=""></div></div>';
    $('[data-title]', li).textContent = message;
    ol.appendChild(li);
    var h = li.getBoundingClientRect().height;
    li.style.setProperty('--initial-height', h + 'px');
    ol.style.setProperty('--front-toast-height', h + 'px');
    requestAnimationFrame(function () { li.setAttribute('data-mounted', 'true'); });
    setTimeout(function () {
      li.setAttribute('data-removed', 'true');
      setTimeout(function () { li.remove(); }, 400);
    }, 4000);
  }

  /* ------------------------------------------------------------------ */
  /* Reveal on scroll                                                    */
  /* ------------------------------------------------------------------ */
  var revealObserver = null;
  function reveal(el) {
    el.classList.remove('translate-y-8', 'opacity-0');
    el.classList.add('translate-y-0', 'opacity-100');
  }
  function observeReveal(scope) {
    var els = $$('[data-reveal]', scope).filter(function (el) { return el.classList.contains('opacity-0'); });
    if (!('IntersectionObserver' in window)) { els.forEach(reveal); return; }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { reveal(en.target); revealObserver.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ------------------------------------------------------------------ */
  /* Scroll lock + overlay helpers                                       */
  /* ------------------------------------------------------------------ */
  var openLayers = 0;
  function lock() { openLayers++; document.documentElement.classList.add('moonhug-lock'); }
  function unlock() { openLayers = Math.max(0, openLayers - 1); if (!openLayers) document.documentElement.classList.remove('moonhug-lock'); }

  function makeLayer(root, overlay, dialog, closeDelay, onOpen) {
    var isOpen = false;
    var api = {
      open: function () {
        if (isOpen) return;
        isOpen = true;
        root.hidden = false;
        overlay.setAttribute('data-state', 'open');
        dialog.setAttribute('data-state', 'open');
        lock();
        if (onOpen) onOpen();
      },
      close: function () {
        if (!isOpen) return;
        isOpen = false;
        overlay.setAttribute('data-state', 'closed');
        dialog.setAttribute('data-state', 'closed');
        setTimeout(function () { if (!isOpen) root.hidden = true; }, closeDelay);
        unlock();
      },
      isOpen: function () { return isOpen; }
    };
    overlay.addEventListener('click', api.close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) api.close(); });
    return api;
  }

  /* ------------------------------------------------------------------ */
  /* Header: dropdowns, search, mobile sheet, counts                     */
  /* ------------------------------------------------------------------ */
  function initDropdowns() {
    var openName = null;
    function close(name) {
      var wrap = $('[data-dropdown="' + name + '"]');
      var trig = $('[data-dropdown-trigger="' + name + '"]');
      if (!wrap) return;
      var menu = $('[role="menu"]', wrap);
      menu.setAttribute('data-state', 'closed');
      if (trig) { trig.setAttribute('aria-expanded', 'false'); trig.setAttribute('data-state', 'closed'); }
      setTimeout(function () { if (openName !== name) wrap.hidden = true; }, 150);
      if (openName === name) openName = null;
    }
    function open(name, trig) {
      if (openName) close(openName);
      var wrap = $('[data-dropdown="' + name + '"]');
      if (!wrap) return;
      var menu = $('[role="menu"]', wrap);
      wrap.hidden = false;
      var r = trig.getBoundingClientRect();
      var w = menu.getBoundingClientRect().width;
      var left = trig.getAttribute('data-align') === 'end' ? r.right - w : r.left;
      left = Math.max(8, Math.min(left, window.innerWidth - w - 8));
      wrap.style.left = left + 'px';
      wrap.style.top = (r.bottom + 4) + 'px';
      menu.style.setProperty('--radix-dropdown-menu-content-transform-origin', trig.getAttribute('data-align') === 'end' ? '100% 0px' : '0% 0px');
      menu.style.setProperty('--radix-dropdown-menu-content-available-height', (window.innerHeight - r.bottom - 12) + 'px');
      menu.setAttribute('data-state', 'open');
      trig.setAttribute('aria-expanded', 'true');
      trig.setAttribute('data-state', 'open');
      openName = name;
    }
    $$('[data-dropdown-trigger]').forEach(function (trig) {
      trig.addEventListener('click', function (e) {
        e.stopPropagation();
        var name = trig.getAttribute('data-dropdown-trigger');
        if (openName === name) close(name); else open(name, trig);
      });
    });
    document.addEventListener('click', function (e) {
      if (!openName) return;
      var wrap = $('[data-dropdown="' + openName + '"]');
      if (wrap && wrap.contains(e.target) && !e.target.closest('[role="menuitem"]')) return;
      close(openName);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openName) close(openName); });
    window.addEventListener('resize', function () { if (openName) close(openName); });
    window.addEventListener('scroll', function () { if (openName) close(openName); }, { passive: true });
    $$('[data-locale-option]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var label = $('[data-locale-label]');
        if (label) label.textContent = opt.getAttribute('data-locale-option');
      });
    });
  }

  var searchItems = null;
  function loadSearchItems() {
    if (searchItems) return searchItems;
    var el = document.getElementById('moonhug-search-data');
    try { searchItems = JSON.parse((el ? el.textContent : '[]').replace(/,\s*\]\s*$/, ']')); } catch (e) { searchItems = []; }
    return searchItems;
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function renderSearch(q) {
    var box = $('[data-search-results]');
    if (!box) return;
    var items = loadSearchItems();
    var t = (q || '').trim().toLowerCase();
    var list = t ? items.filter(function (p) { return p.title.toLowerCase().indexOf(t) > -1; }) : items.slice(0, 4);
    if (!list.length) { box.innerHTML = '<p class="text-sm text-muted-foreground">No results found.</p>'; return; }
    box.innerHTML = '<ul class="space-y-4">' + list.map(function (p) {
      return '<li><a class="flex items-center gap-4 transition-opacity hover:opacity-70" href="' + escapeHtml(p.url) + '">' +
        (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" class="h-16 w-12 object-cover"/>' : '') +
        '<span class="flex-1 text-sm tracking-[0.08em] uppercase">' + escapeHtml(p.title) + '</span><span class="text-sm text-muted-foreground">' + p.price + '</span></a></li>';
    }).join('') + '</ul>';
  }
  function initSearch() {
    var root = $('[data-search-root]');
    if (!root) return;
    var input = $('[data-search-input]', root);
    var layer = makeLayer(root, $('[data-search-overlay]', root), $('[data-search-dialog]', root), 200, function () {
      renderSearch(input.value);
      setTimeout(function () { input.focus(); }, 20);
    });
    $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', layer.open); });
    $('[data-search-close]', root).addEventListener('click', layer.close);
    input.addEventListener('input', function () { renderSearch(input.value); });
    root.addEventListener('click', function (e) { if (e.target.closest('[data-search-results] a')) layer.close(); });
  }
  function initSheet() {
    var root = $('[data-sheet-root]');
    if (!root) return;
    var layer = makeLayer(root, $('[data-sheet-overlay]', root), $('[data-sheet-dialog]', root), 300);
    $$('[data-sheet-open]').forEach(function (b) { b.addEventListener('click', layer.open); });
    $('[data-sheet-close]', root).addEventListener('click', layer.close);
    $$('nav a', root).forEach(function (a) { a.addEventListener('click', layer.close); });
  }

  /* Wishlist (zustand persist format: {"state":{"handles":[...]},"version":0}) */
  var WL_KEY = 'moonhug-wishlist';
  function wlGet() {
    try { var o = JSON.parse(lsGet(WL_KEY) || 'null'); return (o && o.state && Array.isArray(o.state.handles)) ? o.state.handles : []; }
    catch (e) { return []; }
  }
  function wlSet(handles) { lsSet(WL_KEY, JSON.stringify({ state: { handles: handles }, version: 0 })); }
  function wlToggle(handle) {
    var hs = wlGet();
    var i = hs.indexOf(handle);
    if (i > -1) hs.splice(i, 1); else hs.push(handle);
    wlSet(hs);
    syncWishlistUI();
  }
  function syncWishlistUI() {
    var hs = wlGet();
    var count = $('[data-wishlist-count]');
    if (count) { count.textContent = hs.length > 0 ? hs.length : ''; count.hidden = hs.length === 0; }
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = hs.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      var svg = $('svg', btn);
      if (svg) svg.classList.toggle('fill-foreground', on);
    });
    var grid = $('[data-wishlist-grid]');
    if (grid && $('[data-wishlist-item]', grid)) {
      var shown = 0;
      $$('[data-wishlist-item]', grid).forEach(function (item) {
        var on = hs.indexOf(item.getAttribute('data-wishlist-item')) > -1;
        item.hidden = !on;
        if (on) {
          item.style.transitionDelay = ((shown % 3) * 90) + 'ms';
          var badge = $('article a span.absolute', item);
          if (badge && badge.textContent.trim() === 'New') badge.hidden = shown >= 2;
          var img = $('article img', item);
          if (img) img.setAttribute('loading', shown < 3 ? 'eager' : 'lazy');
          shown++;
        }
      });
      grid.hidden = shown === 0;
      var empty = $('[data-wishlist-empty]');
      if (empty) empty.hidden = shown > 0;
      observeReveal(grid);
    }
  }
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      wlToggle(btn.getAttribute('data-wishlist-toggle'));
    });
    window.addEventListener('storage', function (e) { if (e.key === WL_KEY) syncWishlistUI(); });
    syncWishlistUI();
  }

  function setCartCount(n) {
    var el = $('[data-cart-count]');
    if (!el) return;
    el.textContent = n > 0 ? n : '';
    el.hidden = !(n > 0);
  }

  /* ------------------------------------------------------------------ */
  /* Accordions (Radix behaviour)                                        */
  /* ------------------------------------------------------------------ */
  function setItemState(item, open) {
    var state = open ? 'open' : 'closed';
    var trig = $('[data-accordion-trigger]', item);
    var content = $('[data-accordion-content]', item);
    item.setAttribute('data-state', state);
    trig.parentElement.setAttribute('data-state', state);
    trig.setAttribute('data-state', state);
    trig.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      content.style.animationName = 'none';
      content.hidden = false;
      var h = content.getBoundingClientRect().height;
      content.style.setProperty('--radix-collapsible-content-height', h + 'px');
      content.setAttribute('data-state', 'open');
      void content.offsetWidth;
      content.style.animationName = '';
    } else {
      var hh = content.getBoundingClientRect().height;
      content.style.setProperty('--radix-collapsible-content-height', hh + 'px');
      content.setAttribute('data-state', 'closed');
      var finish = function () { if (content.getAttribute('data-state') === 'closed') content.hidden = true; };
      var t = setTimeout(finish, 260);
      content.addEventListener('animationend', function onEnd() { content.removeEventListener('animationend', onEnd); clearTimeout(t); finish(); });
    }
  }
  function initAccordions(scope) {
    $$('[data-accordion]', scope).forEach(function (acc) {
      if (acc.__moonhugAcc) return;
      acc.__moonhugAcc = true;
      var single = acc.getAttribute('data-accordion') === 'single';
      var items = $$(':scope > [data-accordion-item]', acc);
      items.forEach(function (item) {
        $('[data-accordion-trigger]', item).addEventListener('click', function () {
          var isOpen = item.getAttribute('data-state') === 'open';
          if (single && !isOpen) items.forEach(function (o) { if (o !== item && o.getAttribute('data-state') === 'open') setItemState(o, false); });
          setItemState(item, !isOpen);
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Loop carousel (Embla-like): hero + reviews                          */
  /* ------------------------------------------------------------------ */
  function LoopCarousel(root, opts) {
    var viewport = $('[data-viewport]', root);
    var track = $('[data-track]', root);
    var slides = $$(':scope > [data-slide]', track);
    var n = slides.length;
    if (!n) return null;
    var before = slides.map(function (s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-clone', ''); return c; });
    var after = slides.map(function (s) { var c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-clone', ''); return c; });
    before.forEach(function (c) { track.insertBefore(c, slides[0]); });
    after.forEach(function (c) { track.appendChild(c); });
    $$('[data-clone] img', track).forEach(function (img) { img.setAttribute('loading', 'lazy'); });
    var all = $$(':scope > *', track);
    var pos = n; // index into `all`
    var duration = opts.duration || 700;
    var timer = null;
    var paused = false;

    function slideW() { return all[0].getBoundingClientRect().width; }
    function apply(animate) {
      track.style.transition = animate ? 'transform ' + duration + 'ms cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
      track.style.transform = 'translate3d(' + (-pos * slideW()) + 'px,0px,0px)';
    }
    function selected() { return ((pos - n) % n + n) % n; }
    function go(newPos) {
      pos = newPos;
      apply(true);
      if (opts.onSelect) opts.onSelect(selected(), all, pos);
    }
    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      if (pos < n || pos >= 2 * n) { pos = n + selected(); apply(false); if (opts.onSelect) opts.onSelect(selected(), all, pos, true); }
    });
    var api = {
      next: function () { go(pos + 1); },
      prev: function () { go(pos - 1); },
      to: function (i) { go(n + i); },
      selected: selected,
      count: n,
      restart: function () { if (timer) clearInterval(timer); if (opts.autoplay && !reducedMotion()) timer = setInterval(function () { if (!paused) api.next(); }, opts.autoplay); },
      pause: function (v) { paused = v; }
    };
    // drag / swipe
    var startX = null, startY = null, dx = 0, dragging = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      startX = e.clientX; startY = e.clientY; dx = 0; dragging = false;
    });
    viewport.addEventListener('pointermove', function (e) {
      if (startX === null) return;
      dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - startY)) { dragging = true; }
      if (dragging) {
        track.style.transition = 'none';
        track.style.transform = 'translate3d(' + (-pos * slideW() + dx) + 'px,0px,0px)';
      }
    });
    var end = function () {
      if (startX === null) return;
      if (dragging) {
        if (dx < -50) api.next(); else if (dx > 50) api.prev(); else apply(true);
        api.restart();
      }
      startX = null;
    };
    viewport.addEventListener('pointerup', end);
    viewport.addEventListener('pointercancel', end);
    viewport.addEventListener('pointerleave', end);
    viewport.addEventListener('click', function (e) { if (dragging) { e.preventDefault(); e.stopPropagation(); dragging = false; } }, true);
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
    window.addEventListener('resize', function () { apply(false); });
    apply(false);
    if (opts.onSelect) opts.onSelect(selected(), all, pos, true);
    api.restart();
    return api;
  }

  function initHero() {
    var root = $('[data-hero-carousel]');
    if (!root) return;
    var dots = $$('[data-hero-dot]', root);
    var car = LoopCarousel(root, {
      duration: 900,
      autoplay: 6500,
      onSelect: function (sel, all, pos) {
        dots.forEach(function (d, i) {
          d.classList.toggle('bg-primary-foreground', i === sel);
          d.classList.toggle('bg-primary-foreground/40', i !== sel);
        });
        all.forEach(function (slide, i) {
          var img = $('[data-hero-img]', slide);
          if (!img) return;
          var active = i === pos;
          img.classList.toggle('scale-[1.02]', active);
          img.classList.toggle('md:scale-100', active);
          img.classList.toggle('scale-100', !active);
        });
      }
    });
    if (!car) return;
    dots.forEach(function (d, i) { d.addEventListener('click', function () { car.to(i); car.restart(); }); });
  }

  function initReviewCarousel() {
    var root = $('[data-review-carousel]');
    if (!root) return;
    var counter = $('[data-counter]', root);
    var pad = function (x) { return String(x).padStart(2, '0'); };
    var car = LoopCarousel(root, {
      duration: 650,
      autoplay: 5200,
      onSelect: function (sel) { if (counter) counter.textContent = pad(sel + 1) + ' / ' + pad(car ? car.count : $$('[data-track] > [data-slide]:not([data-clone])', root).length); }
    });
    if (!car) return;
    if (counter) counter.textContent = pad(car.selected() + 1) + ' / ' + pad(car.count);
    $('[data-prev]', root).addEventListener('click', function () { car.prev(); });
    $('[data-next]', root).addEventListener('click', function () { car.next(); });
    var vp = $('[data-viewport]', root);
    vp.addEventListener('mouseenter', function () { car.pause(true); });
    vp.addEventListener('mouseleave', function () { car.pause(false); });
    vp.addEventListener('focusin', function () { car.pause(true); });
    vp.addEventListener('focusout', function () { car.pause(false); });
  }

  /* ------------------------------------------------------------------ */
  /* Cart helpers                                                        */
  /* ------------------------------------------------------------------ */
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function cartOriginalTotal(cart) {
    return (cart.items || []).reduce(function (s, it) { return s + (it.original_line_price != null ? it.original_line_price : it.original_price * it.quantity); }, 0);
  }
  function applyThreshold(cart) {
    // 20% (MOONHUG20) on orders above $99.99.
    if (!V.thresholdCode) return Promise.resolve(cart);
    if (cartOriginalTotal(cart) > 9999) return postJSON('/cart/update.js', { discount: V.thresholdCode }).catch(function () { return cart; });
    return Promise.resolve(cart);
  }
  function goCheckout() { setTimeout(function () { window.location.href = withTtclid('/checkout'); }, 800); }

  /* ------------------------------------------------------------------ */
  /* Product page                                                        */
  /* ------------------------------------------------------------------ */
  var COLOR_NAMES = ['color', 'colore', 'colour', 'farbe'];
  var DE_COLOR = { white: 'White', weiss: 'White', black: 'Black', schwarz: 'Black' };
  var ATC_BASE = 'inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary text-primary-foreground shadow hover:bg-primary/90 px-4 py-2 btn-luxe h-auto';

  function initProduct() {
    var root = $('[data-product-root]');
    var jsonEl = $('[data-product-json]');
    if (!root || !jsonEl) return;
    var P;
    try { P = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = P.variants;
    var firstAvail = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var initial = variants.filter(function (v) { return v.id === P.initialVariant; })[0] || firstAvail;
    var sel = initial.options.slice();

    function current() {
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || firstAvail;
    }

    // Gallery
    var main = $('[data-gallery-main]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) { main.src = btn.getAttribute('data-src'); main.srcset = btn.getAttribute('data-srcset'); main.alt = btn.getAttribute('data-alt'); }
        thumbs.forEach(function (b) { b.classList.toggle('border-ink', b === btn); b.classList.toggle('border-transparent', b !== btn); });
      });
    });

    // Feature CTA -> scroll to buy area
    $$('[data-scroll-to]', root).forEach(function (b) {
      b.addEventListener('click', function () { var t = document.getElementById(b.getAttribute('data-scroll-to')); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });

    // Reviews toggles
    $$('[data-reviews]', root).forEach(function (sec) {
      var btn = $('[data-reviews-more]', sec);
      if (!btn) return;
      var items = $$('[data-review-item]', sec);
      var total = items.length;
      var initialCount = Number(btn.getAttribute('data-initial')) || 12;
      var paged = sec.getAttribute('data-mode') === 'paged';
      var visible = initialCount;
      var expanded = false;
      var grid = $('[data-reviews-grid]', sec);
      function render() { items.forEach(function (it, i) { it.hidden = i >= visible; }); }
      btn.addEventListener('click', function () {
        if (paged) {
          if (visible < total) { visible = Math.min(visible + 6, total); }
          else { visible = initialCount; if (grid) grid.scrollIntoView({ block: 'start' }); }
          btn.textContent = visible < total ? 'Show more reviews' : 'Show fewer reviews';
        } else {
          expanded = !expanded;
          visible = expanded ? total : initialCount;
          btn.textContent = expanded ? 'Show fewer reviews' : 'Show more reviews';
        }
        render();
      });
    });

    var lowStock = $('[data-low-stock]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);

    function updateSizeGuide(v) {
      if (P.sizeIndex < 0) return;
      var size = (v && v.options[P.sizeIndex]) || sel[P.sizeIndex] || '';
      var norm = '|' + String(size).toUpperCase().replace(/\s+/g, '') + '|';
      $$('[data-size-row]', root).forEach(function (row) {
        var keys = row.getAttribute('data-size-row');
        var inStore = row.getAttribute('data-in-store') === 'true';
        var isSel = size && keys.indexOf(norm) > -1;
        row.classList.toggle('bg-accent', !!isSel);
        row.classList.toggle('bg-muted/30', !isSel && inStore);
      });
    }

    if (root.getAttribute('data-zip') !== 'true') {
      // ---- standard option pickers
      var groups = $$('[data-option-group]', root);
      var atc = $('[data-add-to-cart]', root);
      var loading = false;
      var addedFlash = false;
      var availFor = function (idx, value) {
        return variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return i === idx ? o === value : (!sel[i] || sel[i] === o); });
        });
      };
      var refresh = function () {
        var v = current();
        groups.forEach(function (g) {
          var idx = Number(g.getAttribute('data-option-index'));
          var kind = g.getAttribute('data-kind');
          var label = $('[data-option-label]', g);
          if (label) label.textContent = sel[idx] || '';
          $$('[data-option-value]', g).forEach(function (b) {
            var val = b.getAttribute('data-option-value');
            var on = sel[idx] === val;
            var av = availFor(idx, val);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (kind === 'color') {
              b.className = 'relative h-10 min-w-10 rounded-full border-2 px-3 text-xs font-semibold uppercase transition-all ' + (on ? 'border-ink scale-105' : 'border-border hover:border-ink') + (av ? '' : ' opacity-40');
            } else {
              b.className = 'min-w-12 border px-4 py-3 text-xs font-semibold tracking-[0.1em] uppercase transition-colors ' + (on ? 'border-ink bg-ink text-primary-foreground' : 'border-border hover:border-ink') + (av ? '' : ' line-through opacity-40');
            }
          });
        });
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (compareEl) {
          var show = v.compare && v.compare > v.price;
          compareEl.hidden = !show;
          compareEl.textContent = show ? fmt(v.compare) : '';
        }
        if (lowStock) lowStock.hidden = !v.low;
        if (atc) {
          var soldOut = !v.available;
          atc.disabled = loading || soldOut;
          atc.textContent = soldOut ? 'Sold out' : loading ? 'Adding…' : addedFlash ? 'Added to cart' : 'Add to cart';
        }
        updateSizeGuide(v);
      };
      groups.forEach(function (g) {
        var idx = Number(g.getAttribute('data-option-index'));
        $$('[data-option-value]', g).forEach(function (b) {
          b.addEventListener('click', function () { sel[idx] = b.getAttribute('data-option-value'); refresh(); });
        });
      });
      if (atc) {
        atc.addEventListener('click', function () {
          var v = current();
          if (!v || !v.available || loading) return;
          loading = true; refresh();
          postJSON('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] })
            .then(function () { return getCart(); })
            .then(function (cart) { setCartCount(cart.item_count); return applyThreshold(cart); })
            .then(function () { goCheckout(); })
            .catch(function () {
              loading = false; addedFlash = false; refresh();
              toast('Could not add to cart.', 'error');
            });
        });
      }
      refresh();
    } else {
      initBundle(root, P, variants, firstAvail, updateSizeGuide);
    }

    if (lowStock && root.getAttribute('data-zip') === 'true') lowStock.hidden = !firstAvail.low;
  }

  /* Bundle selector (Zip Back Hoodie) */
  function initBundle(root, P, variants, firstAvail, updateSizeGuide) {
    var box = $('[data-bundle]', root);
    if (!box) return;
    var ci = P.colorIndex, si = P.sizeIndex;
    var colors = [];
    variants.forEach(function (v) { var c = ci > -1 ? v.options[ci] : null; if (c && colors.indexOf(c) < 0) colors.push(c); });
    var sizes = (P.sizeOrder && P.sizeOrder.length) ? P.sizeOrder.slice() : [];
    if (!sizes.length && si > -1) variants.forEach(function (v) { if (sizes.indexOf(v.options[si]) < 0) sizes.push(v.options[si]); });
    var base = firstAvail;
    var start = { color: ci > -1 ? base.options[ci] : '', size: si > -1 ? base.options[si] : '' };
    var qty = 1;
    var picks = [Object.assign({}, start), Object.assign({}, start)];
    var loading = false;
    var Q = 0.192;
    var price = base.price; // cents
    var compare = base.compare && base.compare > 0 ? base.compare : price;
    var round2 = function (x) { return Math.round(x); };
    var J = function (n) { var regular = price * n; var total = n === 2 ? round2(regular * (1 - Q)) : regular; return { total: total, regular: regular }; };
    var find = function (p) { return variants.filter(function (v) { return (ci < 0 || v.options[ci] === p.color) && (si < 0 || v.options[si] === p.size); })[0]; };
    var ok = function (c, s) { var v = find({ color: c, size: s }); return !!(v && v.available); };
    var label = function (c) { return DE_COLOR[String(c).toLowerCase()] || c; };
    var esc = escapeHtml;

    function selectsHtml() {
      var cls = 'h-10 w-full min-w-0 border border-border bg-background px-2 text-xs font-medium';
      return '<div class="mt-4 space-y-2">' + picks.slice(0, qty).map(function (p, idx) {
        var colorSel = ci > -1 ? '<select aria-label="Color #' + (idx + 1) + '" class="' + cls + '" data-pick="' + idx + '" data-field="color">' + colors.map(function (c) {
          var dis = !sizes.some(function (s) { return ok(c, s); });
          return '<option value="' + esc(c) + '"' + (c === p.color ? ' selected' : '') + (dis ? ' disabled' : '') + '>' + esc(label(c)) + '</option>';
        }).join('') + '</select>' : '';
        var sizeSel = si > -1 ? '<select aria-label="Size #' + (idx + 1) + '" class="' + cls + '" data-pick="' + idx + '" data-field="size">' + sizes.map(function (s) {
          var av = ok(p.color, s);
          return '<option value="' + esc(s) + '"' + (s === p.size ? ' selected' : '') + (av ? '' : ' disabled') + '>' + esc(s) + (av ? '' : ' – sold out') + '</option>';
        }).join('') + '</select>' : '';
        return '<div class="flex items-center gap-2"><span class="w-6 text-xs font-semibold">#' + (idx + 1) + '</span>' + colorSel + sizeSel + '</div>';
      }).join('') + '</div>';
    }
    function cardHtml(n) {
      var active = qty === n;
      var t = J(n);
      var save = Math.round(compare * n - t.total);
      var strike = compare * n;
      return '<div role="radio" aria-checked="' + active + '" tabindex="0" data-qty="' + n + '" class="cursor-pointer p-4 transition-colors ' + (active ? 'border-2 border-ink bg-secondary' : 'border border-border bg-background') + '">' +
        '<div class="flex items-start gap-3"><span class="mt-1 flex size-5 shrink-0 items-center justify-center rounded-full border-2 ' + (active ? 'border-ink' : 'border-border') + '">' + (active ? '<span class="size-2.5 rounded-full bg-ink"></span>' : '') + '</span>' +
        '<div class="flex-1"><p class="flex flex-wrap items-center gap-2 text-base font-bold">' + n + (n === 1 ? ' piece' : ' pieces') + (save > 0 ? '<span class="bg-ink px-2 py-0.5 text-[0.65rem] font-semibold text-primary-foreground">Save ' + fmt(save) + '</span>' : '') + '</p><p class="text-xs font-semibold text-muted-foreground">Free shipping</p></div>' +
        '<div class="text-right"><p class="text-base font-bold">' + fmt(t.total) + '</p>' + (strike > t.total ? '<p class="text-xs text-muted-foreground/70 line-through">' + fmt(strike) + '</p>' : '') + '</div></div>' +
        (active ? '<div data-stop>' + selectsHtml() + '</div>' : '') + '</div>';
    }
    function render() {
      var chosen = picks.slice(0, qty).map(find);
      var allOk = chosen.every(function (v) { return v && v.available; });
      var amount = qty === 1 ? J(1).total : J(2).total;
      var btnText = allOk ? (loading ? 'Adding…' : 'Add to cart · ' + fmt(amount)) : 'Sold out';
      box.innerHTML = '<div class="flex items-center gap-3"><span class="h-px flex-1 bg-border"></span><span class="text-[0.7rem] font-bold tracking-[0.2em] uppercase">Fall Sale</span><span class="h-px flex-1 bg-border"></span></div>' +
        '<div class="mt-4 space-y-4">' + cardHtml(1) + '<div><div class="bg-ink px-4 py-1 text-[0.65rem] font-bold tracking-[0.2em] uppercase text-primary-foreground">Most popular</div>' + cardHtml(2) + '</div></div>' +
        '<div id="kaufbereich" class="mt-4 scroll-mt-32"><button type="button" class="' + esc(box.getAttribute('data-buy-class')) + '"' + ((loading || !allOk) ? ' disabled' : '') + ' data-bundle-add>' + esc(btnText) + '</button></div>';
      updateSizeGuide({ options: (function () { var o = base.options.slice(); if (si > -1) o[si] = start.size; return o; })() });
    }
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-stop]')) return;
      var card = e.target.closest('[data-qty]');
      if (card) { qty = Number(card.getAttribute('data-qty')); render(); return; }
      if (e.target.closest('[data-bundle-add]')) add();
    });
    box.addEventListener('keydown', function (e) {
      var card = e.target.closest('[data-qty]');
      if (card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); qty = Number(card.getAttribute('data-qty')); render(); }
    });
    box.addEventListener('change', function (e) {
      var s = e.target.closest('select[data-pick]');
      if (!s) return;
      var i = Number(s.getAttribute('data-pick'));
      picks[i][s.getAttribute('data-field')] = s.value;
      render();
    });
    function add() {
      var chosen = picks.slice(0, qty).map(find);
      if (loading || !chosen.every(function (v) { return v && v.available; })) return;
      loading = true; render();
      var items = [];
      chosen.forEach(function (v) {
        var ex = items.filter(function (it) { return it.id === v.id; })[0];
        if (ex) ex.quantity += 1; else items.push({ id: v.id, quantity: 1 });
      });
      postJSON('/cart/add.js', { items: items })
        .then(function () {
          if (chosen.length === 2 && V.bundleCode) return postJSON('/cart/update.js', { discount: V.bundleCode }).catch(function () {});
          return getCart().then(applyThreshold);
        })
        .then(function () { goCheckout(); })
        .catch(function () { loading = false; render(); toast('Could not add to cart.', 'error'); });
    }
    render();
  }

  /* ------------------------------------------------------------------ */
  /* Cart page                                                           */
  /* ------------------------------------------------------------------ */
  function initCart() {
    var root = $('[data-cart-root]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var busy = false;
    function setBusy(v) {
      busy = v;
      $$('[data-cart-qty]', root).forEach(function (b) { if (b.getAttribute('aria-label')) b.disabled = v; });
      var co = $('[data-checkout-button]', root);
      if (co) { co.disabled = v; co.textContent = v ? 'Updating…' : 'Checkout'; }
    }
    function rerender() {
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-root]');
          if (fresh) root.innerHTML = fresh.innerHTML;
        });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cart-qty]');
      if (!b || busy) return;
      setBusy(true);
      postJSON('/cart/change.js', { id: b.getAttribute('data-key'), quantity: Number(b.getAttribute('data-cart-qty')) })
        .then(function (cart) { setCartCount(cart.item_count); return rerender(); })
        .catch(function () {})
        .then(function () { setBusy(false); });
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-checkout-form]');
      if (!form) return;
      e.preventDefault();
      if (busy) return;
      setBusy(true);
      getCart().then(applyThreshold).catch(function () {}).then(function () { goCheckout(); });
    });
    var co = $('[data-checkout-button]', root);
    if (co) { var l = document.createElement('link'); l.rel = 'prefetch'; l.href = '/checkout'; document.head.appendChild(l); }
  }

  /* ------------------------------------------------------------------ */
  /* Forms: newsletter + contact                                         */
  /* ------------------------------------------------------------------ */
  function initNewsletter() {
    var form = $('[data-newsletter-form]');
    if (!form) return;
    var email = $('[data-newsletter-email]', form);
    var consent = $('[data-newsletter-consent]', form);
    var err = $('[data-newsletter-consent-error]', form);
    consent.addEventListener('change', function () { if (consent.checked) err.hidden = true; });
    form.addEventListener('submit', function (e) {
      if (email.value.indexOf('@') < 0) { e.preventDefault(); toast('Please enter a valid email address.', 'error'); return; }
      if (!consent.checked) { e.preventDefault(); err.hidden = false; return; }
    });
    var posted = /[?&]customer_posted=true/.test(window.location.search) || $('[data-newsletter-success]', form);
    if (posted) toast('Thanks — you are now subscribed to our newsletter.', 'success');
    else if ($('.errors', form)) toast('Please enter a valid email address.', 'error');
  }

  function initContact() {
    var form = $('[data-moonhug-contact]') || document.getElementById('moonhug-contact-form');
    if (!form) return;
    var field = function (id) { return form.querySelector('#' + id); };
    var errEl = function (k) { return form.querySelector('[data-error="' + k + '"]'); };
    var setErr = function (k, msg) { var el = errEl(k); if (!el) return; el.textContent = msg || ''; el.hidden = !msg; };
    ['name', 'email', 'order', 'message'].forEach(function (k) {
      var f = field(k);
      if (f) f.addEventListener('input', function () { setErr(k, ''); });
    });
    form.setAttribute('novalidate', '');
    form.addEventListener('submit', function (e) {
      var name = field('name').value.trim();
      var email = field('email').value.trim();
      var order = field('order').value.trim();
      var msg = field('message').value.trim();
      var errs = {};
      if (name.length < 2) errs.name = 'Please enter your name';
      else if (name.length > 100) errs.name = 'Maximum 100 characters';
      if (!/^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+\-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i.test(email) || email.length > 255) errs.email = 'Invalid email address';
      if (order.length > 40) errs.order = 'Maximum 40 characters';
      if (msg.length < 10) errs.message = 'Your message must be at least 10 characters long';
      else if (msg.length > 1000) errs.message = 'Maximum 1000 characters';
      ['name', 'email', 'order', 'message'].forEach(function (k) { setErr(k, errs[k]); });
      if (Object.keys(errs).length) { e.preventDefault(); return; }
      field('name').value = name; field('email').value = email; field('order').value = order; field('message').value = msg;
    });
    if (/[?&]contact_posted=true/.test(window.location.search)) {
      var box = document.createElement('div');
      box.setAttribute('role', 'status');
      box.className = 'mt-6 border border-gold bg-background px-4 py-3 text-sm';
      box.textContent = 'Thank you, we have received your request. We will get back to you within one business day.';
      form.parentNode.insertBefore(box, form);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function boot() {
    captureTtclid();
    initConsentBanner();
    observeReveal(document);
    initDropdowns();
    initSearch();
    initSheet();
    initWishlist();
    initAccordions(document);
    initHero();
    initReviewCarousel();
    initProduct();
    initCart();
    initNewsletter();
    initContact();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
